import React, { useState, useEffect } from "react";
import userReservationStyles from "../../../../assests/styles/views/public/userReservation";
import Footer from "../Footer";
import Navbar from "../Navbar";
import { Get } from "../../../../actions";
import { Get_Email_URL } from "../../../../constants/apiUrls";

const UserReservationLayout = ({ children, classes, disabled, enableLogo }) => {
		const [email, setEmail] = useState("");

	useEffect(() => {
		getEmail()
	}, []);

			const getEmail = () => {
				Get(
					{},
					Get_Email_URL,
					null,
					(res) => {
						setEmail(res.data);
					},
					(err) => {
						
					}
				);
			};
	return (
		<div className={classes.layoutWrapper}>
			<Navbar classes={classes} supportEmail={email} />
			<div className={classes.main}>{children}</div>
			<Footer classes={classes} enableLogo={enableLogo} />
		</div>
	);
};

export default UserReservationLayout;
